import type { MapProvider } from './map-provider.interface';
import { OpenStreetMapProvider } from '../providers/openstreetmap/openstreetmap.provider';

export enum MapProviderType {
  OPENSTREETMAP = 'openstreetmap'
  // Future providers can be added here
  // GOOGLE_MAPS = 'google-maps',
  // MAPBOX = 'mapbox',
  // ECHARTS = 'echarts'
}

export class MapService {
  private static instance: MapService;
  private provider: MapProvider;

  private constructor() {
    this.provider = new OpenStreetMapProvider();
  }

  static getInstance(): MapService {
    if (!MapService.instance) {
      MapService.instance = new MapService();
    }
    return MapService.instance;
  }

  setProvider(type: MapProviderType): void {
    if (this.provider?.destroy) {
      this.provider.destroy();
    }

    switch (type) {
      case MapProviderType.OPENSTREETMAP:
        this.provider = new OpenStreetMapProvider();
        break;
      // Add more providers here in the future
      default:
        this.provider = new OpenStreetMapProvider();
    }
  }

  getProvider(): MapProvider {
    return this.provider;
  }

  getCurrentProviderType(): MapProviderType {
    if (this.provider instanceof OpenStreetMapProvider) {
      return MapProviderType.OPENSTREETMAP;
    }

    return MapProviderType.OPENSTREETMAP;
  }
}
